import { parseApiResponse } from '@/shared/utils/apiResponse';
import { apiDelete, apiGet, apiPatch } from '@/shared/utils/requestBuilder';
import type {
  EscritorioMembro,
  ListarMembrosFilters,
  UpdatePapelDto,
} from '@/types/escritorio/escritorioTypes';

// Rota admin: o escritório vem do path. A rota do cliente (`/escritorios/:id/membros`) é escopada
// pelo header `X-Workspace-Id`, que o `requestBuilder` não envia em `/admin/*` — era por isso que
// o painel listava os membros do escritório do próprio admin, não os do tenant aberto.
const rota = (escritorioId: string) => `/admin/escritorios/${escritorioId}/membros`;

export const membrosTenantService = {
  listar: async (
    escritorioId: string,
    filters?: ListarMembrosFilters,
  ): Promise<EscritorioMembro[]> => {
    const params = new URLSearchParams();
    if (filters?.papel) params.append('papel', filters.papel);
    if (filters?.ativo !== undefined) params.append('ativo', String(filters.ativo));

    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await apiGet(`${rota(escritorioId)}${query}`);

    return parseApiResponse<EscritorioMembro[]>(response);
  },

  atualizarPapel: async (
    escritorioId: string,
    membroId: string,
    papel: UpdatePapelDto['papel'],
  ): Promise<EscritorioMembro> => {
    const response = await apiPatch(`${rota(escritorioId)}/${membroId}/papel`, { papel });

    return parseApiResponse<EscritorioMembro>(response);
  },

  remover: async (escritorioId: string, membroId: string): Promise<void> => {
    const response = await apiDelete(`${rota(escritorioId)}/${membroId}`);

    await parseApiResponse<null>(response, { allowNoContent: true });
  },
};
